(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks/assets/javascripts/use-is-current-draw-playable.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks/assets/javascripts/use-is-current-draw-playable.js');
"use strict";

const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const selectById = svs.components.sport.drawsRedux.globalizedSelectors.selectById;
const _svs$components$sport = svs.components.sport.tipsenShared,
  DrawState = _svs$components$sport.DrawState,
  DisableType = _svs$components$sport.DisableType;
const getCompetitionFactoryInstance = svs.components.tipsen.competition.competitionFactoryInstance.getCompetitionFactoryInstance;
const isDrawOpened = draw => {
  var _draw$drawStateId;
  return ((_draw$drawStateId = draw === null || draw === void 0 ? void 0 : draw.drawStateId) !== null && _draw$drawStateId !== void 0 ? _draw$drawStateId : DrawState.Undefined) === DrawState.Opened;
};
const isDrawBetDisabled = draw => {
  var _draw$regBetDisabled;
  return ((_draw$regBetDisabled = draw === null || draw === void 0 ? void 0 : draw.regBetDisabled) !== null && _draw$regBetDisabled !== void 0 ? _draw$regBetDisabled : DisableType.Regbet) === DisableType.NotDisabled;
};
const isDrawPlayable = draw => {
  if (!draw) {
    return false;
  }
  return isDrawOpened(draw) && isDrawBetDisabled(draw);
};
const useIsDrawRegBetDisabled = (productId, drawNumber) => {
  const drawId = "".concat(productId, "_").concat(drawNumber);
  const draw = useSelector(state => selectById(state, drawId));
  return isDrawBetDisabled(draw);
};
const useIsDrawPlayable = (productId, drawNumber) => {
  const drawId = "".concat(productId, "_").concat(drawNumber);
  const draw = useSelector(state => selectById(state, drawId));
  return isDrawPlayable(draw);
};
const useIsCurrentDrawPlayable = drawId => {
  const _getCompetitionFactor = getCompetitionFactoryInstance().getCompetitionHooksForCms(),
    useCanPlayInCompetitionDraw = _getCompetitionFactor.useCanPlayInCompetitionDraw,
    useActiveCompetitionId = _getCompetitionFactor.useActiveCompetitionId;
  const draw = useCurrentDraw(drawId);
  const activeCompetitionId = useActiveCompetitionId();
  const canPlayInCompetitionDraw = useCanPlayInCompetitionDraw({
    productId: draw.productId,
    drawNumber: draw.drawNumber
  });
  const isDrawOpened = isDrawPlayable(draw);
  return activeCompetitionId ? isDrawOpened && canPlayInCompetitionDraw : isDrawOpened;
};
setGlobal('svs.components.tipsen.hooks', {
  useIsDrawRegBetDisabled,
  useIsCurrentDrawPlayable,
  useIsDrawPlayable
});

 })(window);